<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                </b-card>
                <b-card  v-if="Object.keys(followup).length !== 0 &&  Object.keys(first_followup).length !== 0">
                    <div class="float-right mb-2">
                        <a href="javascript:void(0);"
                           class="btn btn-sm btn-success" title="Download PDF" @click="pdf(followup.trainee_id)">
                            Download as PDF
                        </a>
                    </div>
                    <div  class="table-responsive" style="overflow-x: auto">
                        <table class="table table-bordered table-centered table-striped">
                            <tr>
                                <td></td>
                                <td><strong>Before Training</strong></td>
                                <td><strong>After Training</strong></td>
                            </tr>
                            <tr v-if="first_followup.trade_use != null">
                                <td>Past Occupation</td>
                                <td></td>
                                <td>{{ followup.past_occupation.desc }}</td>
                            </tr>
                            <tr>
                                <td>Present Occupation</td>
                                <td>{{ first_followup.present_occupation.desc }}</td>
                                <td>{{ followup.present_occupation.desc }}</td>
                            </tr>
                            <tr v-if="first_followup.trade_use != null">
                                <td>Past Monthly Income</td>
                                <td></td>
                                <td>{{ followup.current_family_monthly_expense }}</td>
                            </tr>
                            <tr>
                                <td>Present Monthly Income</td>
                                <td>{{ first_followup.present_monthly_income }}</td>
                                <td>{{ followup.present_monthly_income }}</td>
                            </tr>
                            <tr>
                                <td>Family Monthly Income</td>
                                <td>{{ first_followup.family_monthly_income }}</td>
                                <td>{{ followup.family_monthly_income }}</td>
                            </tr>
                            <tr v-if="first_followup.trade_use == null">
                                <td>Current Monthly Expenses of Family</td>
                                <td>{{ first_followup.current_family_monthly_expense }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Training Trade</td>
                                <td>
                                    <span v-for="training_trade in first_followup.training_trades" :key="training_trade.id">
                                    {{ training_trade.desc }} <br>
                                </span>
                                </td>
                                <td>
                                    <span v-for="training_trade in followup.training_trades" :key="training_trade.id">
                                    {{ training_trade.desc }} <br>
                                </span>
                                </td>
                            </tr>

                            <tr>
                                <td>Desi Murgi</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.desi_murgi }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.desi_murgi }}</td>
                            </tr>
                            <tr>
                                <td>Sonali Murgi</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.sonali_murgi }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.sonali_murgi }}</td>
                            </tr>
                            <tr>
                                <td>Broiler</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.broiler }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.broiler }}</td>
                            </tr>
                            <tr>
                                <td>Cockrell</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.cockrell }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.cockrell }}</td>
                            </tr>
                            <tr>
                                <td>Tarki</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.tarki }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.tarki }}</td>
                            </tr>
                            <tr>
                                <td>Hass</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.hass }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.hass }}</td>
                            </tr>
                            <tr>
                                <td>Raj Hass</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.raj_hass }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.raj_hass }}</td>
                            </tr>
                            <tr>
                                <td>Kabutor</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.kabutor }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.kabutor }}</td>
                            </tr>
                            <tr>
                                <td>Goru</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.goru }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.goru }}</td>
                            </tr>
                            <tr>
                                <td>Ghabi</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.ghabi }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.ghabi }}</td>
                            </tr>
                            <tr>
                                <td>Chagol</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.chagol }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.chagol }}</td>
                            </tr>
                            <tr>
                                <td>Bhera</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.bhera }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.bhera }}</td>
                            </tr>
                            <tr>
                                <td>Buffalo</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.buffalo }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.buffalo }}</td>
                            </tr>
                            <tr>
                                <td>Pukor</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.pukor }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.pukor }}</td>
                            </tr>
                            <tr>
                                <td>Computer</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.computer }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.computer }}</td>
                            </tr>
                            <tr>
                                <td>Sewing</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.sewing }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.sewing }}</td>
                            </tr>
                            <tr>
                                <td>Welding</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.welding }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.welding }}</td>
                            </tr>
                            <tr>
                                <td>Led</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.led }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.led }}</td>
                            </tr>
                            <tr>
                                <td>Dukan</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.dukan }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.dukan }}</td>
                            </tr>
                            <tr>
                                <td>Others</td>
                                <td v-if="first_followup.followup_income_source != null">{{ first_followup.followup_income_source.others }}</td>
                                <td v-if="followup.followup_income_source != null">{{ followup.followup_income_source.others }}</td>
                            </tr>

                            <tr>
                                <td>Are You Jobholder?</td>
                                <td>
                                    <span v-if="first_followup.is_job_holder == 1">Yes</span>
                                    <span v-if="first_followup.is_job_holder == 0">No</span>
                                </td>
                                <td>
                                    <span v-if="followup.is_job_holder == 1">Yes</span>
                                    <span v-if="followup.is_job_holder == 0">No</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Job Description</td>
                                <td>{{ first_followup.job_description }}</td>
                                <td>{{ followup.job_description }}</td>
                            </tr>
                            <tr>
                                <td>Any Business?</td>
                                <td>
                                    <span v-if="first_followup.doing_business == 1">Yes</span>
                                    <span v-if="first_followup.doing_business == 0">No</span>
                                </td>
                                <td>
                                    <span v-if="followup.doing_business == 1">Yes</span>
                                    <span v-if="followup.doing_business == 0">No</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Business Type</td>
                                <td>
                                    <span v-for="business_type in first_followup.business_types" :key="business_type.id">
                                    {{ business_type.desc }} <br>
                                </span>
                                </td>
                                <td>
                                    <span v-for="business_type in followup.business_types" :key="business_type.id">
                                    {{ business_type.desc }} <br>
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Business Money Source</td>
                                <td>
                                     <span v-for="money_source in first_followup.money_sources" :key="money_source.id">
                                    {{ money_source.desc }} <br>
                                </span>
                                </td>
                                <td>
                                     <span v-for="money_source in followup.money_sources" :key="money_source.id">
                                    {{ money_source.desc }} <br>
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td>What are you doing with the money you get from training?</td>
                                <td>
                                    <span v-for="business in first_followup.businesses" :key="business.id">
                                        {{ business.desc }} <br>
                                </span>
                                </td>
                                <td>
                                    <span v-for="business in followup.businesses" :key="business.id">
                                        {{ business.desc }} <br>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Are you receiving any service from the government office?</td>
                                <td>
                                    <span v-if="first_followup.govt_help == 1">Yes</span>
                                    <span v-if="first_followup.govt_help == 0">No</span>
                                </td>
                                <td>
                                    <span v-if="followup.govt_help == 1">Yes</span>
                                    <span v-if="followup.govt_help == 0">No</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Govt Help Description</td>
                                <td>{{ first_followup.govt_help_description }}</td>
                                <td>{{ followup.govt_help_description }}</td>
                            </tr>
                            <tr>
                                <td>Has there been any benefit to using advanced technology?</td>
                                <td>
                                    <span v-if="first_followup.is_technology_use == 0">Too much</span>
                                    <span v-if="first_followup.is_technology_use == 1">More</span>
                                    <span v-if="first_followup.is_technology_use == 2">Roughly</span>
                                    <span v-if="first_followup.is_technology_use == 3">No</span>
                                </td>
                                <td>
                                    <span v-if="followup.is_technology_use == 0">Too much</span>
                                    <span v-if="followup.is_technology_use == 1">More</span>
                                    <span v-if="followup.is_technology_use == 2">Roughly</span>
                                    <span v-if="followup.is_technology_use == 3">No</span>
                                </td>
                            </tr>
                            <tr>
                                <td>How much have you benefited financially from training?</td>
                                <td>
                                    <span v-if="first_followup.is_financially_improvement == 0">Too much</span>
                                    <span v-if="first_followup.is_financially_improvement == 1">More</span>
                                    <span v-if="first_followup.is_financially_improvement == 2">Roughly</span>
                                    <span v-if="first_followup.is_financially_improvement == 3">No</span>
                                </td>
                                <td>
                                    <span v-if="followup.is_financially_improvement == 0">Too much</span>
                                    <span v-if="followup.is_financially_improvement == 1">More</span>
                                    <span v-if="followup.is_financially_improvement == 2">Roughly</span>
                                    <span v-if="followup.is_financially_improvement == 3">No</span>
                                </td>
                            </tr>
                            <tr>
                                <td>At present, your social status has increased? </td>
                                <td>
                                    <span v-if="first_followup.is_financially_improvement == 0">Too much</span>
                                    <span v-if="first_followup.is_financially_improvement == 1">More</span>
                                    <span v-if="first_followup.is_financially_improvement == 2">Roughly</span>
                                    <span v-if="first_followup.is_financially_improvement == 3">No</span>
                                </td>
                                <td><span v-if="followup.is_financially_improvement == 0">Too much</span>
                                    <span v-if="followup.is_financially_improvement == 1">More</span>
                                    <span v-if="followup.is_financially_improvement == 2">Roughly</span>
                                    <span v-if="followup.is_financially_improvement == 3">No</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Have you ever done any of your trade using advanced technology?</td>
                                <td></td>
                                <td>
                                    <span v-if="followup.doing_business == 1">Yes</span>
                                    <span v-if="followup.doing_business == 0">No</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Training Comparison",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {Layout, PageHeader },
        data() {
            return {
                title: "Training Comparison",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee",
                        active: true
                    }
                ],
                flag: false,
                first_followup: {},
                followup: {},
            };
        },


        mounted() {
            this.trainee_id = this.$route.params.trainee_id;
            this.getTraineeFollowup();
        },
        methods: {
            async getTraineeFollowup() {
                let trainee_id = this.$route.params.trainee_id;
                await http.get("api/followup/comparison/view/" + trainee_id)
                    .then(resource => {
                        this.followup = resource.data.followup
                        this.first_followup = resource.data.first_followup
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            pdf(trainee_id) {
                http.get('/api/followup/comparison/pdf/download/'+ trainee_id, {responseType: 'arraybuffer'})
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'followup.pdf');
                        document.body.appendChild(link);
                        link.click();
                    })
            }
        },
    };
</script>
